<template>
  <div class="search-filter-wrapper">
    <input :placeholder="this.$root.contentText.placeholder" @input="filterSearch" type="text" v-model="search">
  </div>
</template>

<script>
  export default {
    name: 'searchFilter',
    data() {
      return {
        search: null,
      }
    },
    methods: {
      filterSearch() {
        this.$root.setFilter('fullText', this.search)
      }
    },
    created() {
      this.$root.setFilter('fullText', this.search)
    }
  }
</script>

<style lang="scss" scoped>
  div {
    padding: 20px;
    text-align: center;
  }

  input {
    padding: 5px;

    @media (max-width: 1025px) {
      width: calc(100% - 20px);
      border: none;
      border-bottom: 1px solid;
      font-size: 16px;
      padding: 10px;
    }
  }
</style>
